import MainContent from '@/neroli-salon/MainContent'
import { theme } from '@/neroli-salon/common/theme'
import { ScopedCssBaseline, ThemeProvider } from '@mui/material'
import { createRoot } from 'react-dom/client'

const rootElement = document.getElementById('neroli-salon-root')
const template = rootElement?.dataset.template ?? ''
const hasSalon =
  rootElement?.dataset.hasSalon === 'true' || template === 'collection.salon_top' || template === 'collection.salon'
const keyword = rootElement?.dataset.keyword
const logoUrl = rootElement?.dataset.storeLogo

console.log('neroli-salon.tsx')

if (rootElement) {
  console.log('createElement')
  createRoot(rootElement).render(
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <MainContent hasSalon={hasSalon} keyword={keyword ?? ''} logoUrl={logoUrl ?? ''} />
      </ScopedCssBaseline>
    </ThemeProvider>,
  )
}
